const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the filtered content search bar directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Categories} Categories the resource defined to manage Categories
 * @argument {Videos} Videos the resource defined to manage Videos
 * @argument {Files} Files the resource defined to manage Files
 * @argument {Articles} Articles the resource defined to manage Articles
 * @argument {Tracks} Tracks the resource defined to manage Tracks
 * @argument {Presentations} Presentations the resource defined to manage Presentations
 * @argument {Polls} Polls the resource defined to manage Polls
 * @argument {Assessments} Assessments the resource defined to manage Assessments
 */
app.directive('filteredContentSearch', ['Application', 'Authorization', 'Categories', 'Groups', 'AdminContent', '$q', '$translate', function (Application, Authorization, Categories, Groups, AdminContent, $q, $translate) {
  return {
    restrict: 'E',
    scope: {
      onQuery: '&',
      onAdd: '&?',
      onRemove: '&?',
      onAllRemoved: '&?',
      clear: '=',
      placeholder: '@',
      initialValues: '=?',
      multiselect: '=?',
      for: '@',
      type: '=?',
      types: '=?',
      categoryDirectory:'=?',
      myContentOnly:'@',
      contentOnly: '@?',
      pendingContent: '@',
      textDisallowed: '@?',
      forAssignments: '@'
    },
    template: require('../../templates/directives/filtered-content-search.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      // Available query types: department|location|text
      self.queryIds = {};
      self.queries = [];
      self.departments = {};
      self.locations = {};
      self.teams = {};
      self.org_levels = {};
      self.grades = {};
      self.categories = {};
      self.groups = {};
      self.activeFilter = '';
      self.placeholder = $scope.placeholder || '';

      self.flags = Application.features.flags();

      if (!$scope.placeholder) {
        $translate('global.label.search').then(function (translation) {
          self.placeholder = $scope.placeholder || translation;
        });
      }

      var getLineage = function(id, type) {
        var items = [id];
        var children = [];
        var grandChildren = [];

        var addTo = function(id) {
          children.push(id);
          var main = self[type][id];
          if (!main || !main.children || !main.children.length) {
            return;
          }
          for (var i = 0; i < main.children.length; i++) {
            grandChildren.push(main.children[i]);
          }
        };

        if (!self[type][id] || !self[type][id].children || !self[type][id].children.length) {
          return items;
        }

        for (var i = 0; i < self[type][id].children.length; i++) {
          addTo(self[type][id].children[i], children);
        }

        return items.concat(children, grandChildren);
      };

      self.updateQuery = function() {
        var item = {};

        for (var i = 0; i < self.queries.length; i++) {
          switch (self.queries[i].type) {
            case 'location':
              var locations = getLineage(self.queries[i]._id, 'locations');
              item.privacy_locations = '$in,' + locations.length + ',' + locations.join(',');
              break;
            case 'department':
              var departments = getLineage(self.queries[i]._id, 'departments');
              item.privacy_departments = '$in,' + departments.length + ',' + departments.join(',');
              break;
            case 'team':
              var teams = getLineage(self.queries[i]._id, 'teams');
              item.privacy_teams = '$in,' + teams.length + ',' + teams.join(',');
              break;
            case 'org_level':
              var org_levels = getLineage(self.queries[i]._id, 'org_levels');
              item.privacy_org_levels = '$in,' + org_levels.length + ',' + org_levels.join(',');
              break;
            case 'grade':
              var grades = getLineage(self.queries[i]._id, 'grades');
              item.privacy_grades = '$in,' + grades.length + ',' + grades.join(',');
              break;
            case 'group':
              const groups = getLineage(self.queries[i]._id, 'groups');
              item.groups = '$in,' + groups.length + ',' + groups.join(',');
              break;
            case 'category':
              // This can be swapped out to show the category lineage instead of only the category at hand
              // var categories = getLineage(self.queries[i]._id, 'categories');
              // item.linked_category = '$in,' + categories.length + ',' + categories.join(',');
              item.linked_category = self.queries[i]._id;
              break;
            case 'text':
              // if ($scope.for === 'archived' || $scope.myContentOnly) {
                item['$or'] = '10,title,$regex,2,' + self.queries[i].name + ',i,name,$regex,2,' + self.queries[i].name + ',i';
                if ($scope.for === 'users') {
                  item['$or'] = '10,full_name,$regex,2,' + self.queries[i].name + ',i,email,$regex,2,' + self.queries[i].name + ',i';
                }
              //   break;
              // }
              // var place = $scope.for === 'content' || $scope.for === 'assessment' || $scope.for === 'imported_content' || $scope.for === 'scorm' || $scope.for === 'workshop' ? 'title' : 'name';
              // item[place] = '$regex,2,' + self.queries[i].name + ',i';
              break;
            case 'tracks':
            case 'presentations':
            case 'videos':
            case 'articles':
            case 'files':
            case 'polls':
            case 'scorm':
            case 'imported_content':
            case 'workshops':
            case 'journeys':
            case 'assessments':
              item._id = self.queries[i]._id;
              break;
            default:
              break;
          }
        }

        if ($scope.forAssignments) {
          $scope.onQuery({query: self.queries.map(function(item) {return item._id})});
          return;
        }
        $scope.onQuery({query: item});
      };

      self.removeUnique = function(type) {
        for (var i = 0; i < self.queries.length; i++) {
          if (self.queries[i].type === type) {
            var removed = self.queries.splice(i, 1);
            self.queryIds[removed[0]._id] = false;
            return;
          }
        }
      };

      // ------------- start ngTag triggered actions ------------
      self.addingTag = function($tag) {
        if (!$tag.type && $scope.textDisallowed) {
            return false;
        }

        if ($tag.type && ($tag.type === 'locations' || $tag.type === 'departments' || $tag.type === 'teams' || $tag.type === 'org_levels' || $tag.type === 'grades' || $tag.type === 'groups')) {
          self.removeUnique($tag.type);
          return true;
        }
        if (Object.keys($tag).length === 1 && $tag.name) {
          $tag.text = $tag.name;
          $tag._id = $tag.name + '-text';
          $tag.type = 'text';
          self.removeUnique($tag.type);
          return true;
        }
        if ($tag.type) {
          if ($tag.type === 'tracks' || $tag.type === 'presentations' || $tag.type === 'polls' || $tag.type === 'articles' || $tag.type === 'workshops' || $tag.type === 'files' || $tag.type === 'videos' || $tag.type === 'scorm' || $tag.type === 'imported_content') {
            if (!$scope.multiselect) {
              self.queryIds = {};
              self.queries.splice(0);
            }
            return true;
          }
        }
      };

      self.addedTag = function($tag, outside) {
        self.queryIds[$tag._id] = true;
        self.updateQuery();
        if ($scope.onAdd) {
          $scope.onAdd({item: $tag});
        }
      };

      self.removedTag = function($tag) {
        self.queryIds[$tag._id] = false;
        self.updateQuery();
        if ($scope.onRemove) {
          $scope.onRemove({item: $tag});
        }
      };

      self.removeTags = function() {
        self.queries = [];
        self.updateQuery();
        if ($scope.onAllRemoved) {
          $scope.onAllRemoved();
        }
      };
      // ------------- End ngTag triggered actions ------------

      self.outsideAdd = function(item) {
        self.queries.push(item);
        self.addedTag(item, true);
      }

      var legacyName = function(item, type) {
        var name = '';
        var parent;
        var parentName;
        var papa;
        var papaName;

        item.legacyName = item.name;

        if (item.parent) {
          parent = self[type][item.parent];
          parentName = parent.name + ' -> ';
          papa = parent.parent;
          item.legacyName = parentName + item.name;
        }

        if (papa) {
          papa = self[type][papa];
          papaName = papa.name + ' -> ';
          item.legacyName = papaName + parentName + item.name;
        }
      };

      self.sortCategories = function(data) {
        angular.forEach(data, function(cat) {
          if (cat.location) {
            self.locations[cat._id] = cat;
          }
          if (cat.department) {
            self.departments[cat._id] = cat;
          }
          if (cat.team) {
            self.teams[cat._id] = cat;
          }
          if (cat.org_level) {
            self.org_levels[cat._id] = cat;
          }
          if (cat.grade) {
            self.grades[cat._id] = cat;
          }
          if (cat.category) {
            self.categories[cat._id] = cat;
          }
          if (cat.group) {
            self.groups[cat._id] = cat;
          }
        });
        for (var loc in self.locations) {
          legacyName(self.locations[loc], 'locations');
        }
        for (var dep in self.departments) {
          legacyName(self.departments[dep], 'departments');
        }
        for (var team in self.teams) {
          legacyName(self.teams[team], 'teams');
        }
        for (var lev in self.org_levels) {
          legacyName(self.org_levels[lev], 'org_levels');
        }
        for (var grade in self.grades) {
          legacyName(self.grades[grade], 'grades');
        }
        for (var item in self.categories) {
          legacyName(self.categories[item], 'categories');
        }
      };

      self.searchContent = function(query) {
        var typeOptions = ['articles', 'videos', 'files', 'tracks', 'scorm', 'presentations', 'workshops', 'assessments', 'imported_content', 'journey'];
        var types = ''; //should end with a comma, last character gets removed

        if ($scope.for === 'content' || $scope.myContentOnly) {
          // This order is important and used in the response
          // promises.push(Articles.find(query).$promise);
          // promises.push(Files.find(query).$promise);
          // promises.push(Videos.find(query).$promise);
          types += 'articles,videos,files,';
        }

        if ($scope.for === 'reportContent' || $scope.myContentOnly) {
          types += 'articles,videos,files,scorm,imported_content,workshops,tracks,';
        }

        if ($scope.for === 'track' || $scope.myContentOnly) {
          // promises.push(Tracks.find(query).$promise);
          types += 'tracks,';
        }

        if ($scope.for === 'journey' || $scope.myContentOnly) {
          types += 'journeys,';
        }

        if ($scope.for === 'presentation' || $scope.myContentOnly) {
          // promises.push(Presentations.find(query).$promise);
          types += 'presentations,';
        }

        // if ($scope.for === 'poll') {
        //   promises.push(Polls.find(query).$promise);
        // }

        if ($scope.for === 'workshop' || $scope.myContentOnly) {
          // promises.push(Workshops.find(query).$promise);
          types += 'workshops,';
        }

        if ($scope.for === 'assessment' || $scope.myContentOnly) {
          // promises.push(Assessments.find(query).$promise);
          types += 'assessments,';
        }
        
        if ($scope.for === 'scorm' || $scope.myContentOnly) {
          // promises.push(ScormContent.find(query).$promise);
          types += 'scorm,';
        }
        
        if ($scope.for === 'imported_content' || $scope.myContentOnly) {
          // promises.push(ImportedContent.find(query).$promise);
          types += 'imported_content,';
        }

        if (types.length && $scope.for !== 'archived') {
          query.types = types.slice(0, -1);
          if ($scope.types) {
            query.types = $scope.types;
          }
          //re-adding analytics subresource to use correct backend route
          query.subresource = 'analytics'
          return AdminContent.findAnalytics(query).$promise;
        }

        if ($scope.for === 'archived') {
          query.archived = true;
          query.types = types && types.slice(0, -1) || typeOptions.join(',');
          if ($scope.types) {
            query.types = $scope.types;
          }
          return AdminContent.findAnalytics(query).$promise;
        }

        var deferred = $q.defer();
        deferred.resolve({data: []});
        return deferred.promise;
      };

      var placeholders = {
        articles: {name: 'Articles', text: 'Articles', _id: 'articles', placeholder: true},
        files: {name: 'Files', text: 'Files', _id: 'files', placeholder: true},
        videos: {name: 'Videos', text: 'Videos', _id: 'videos', placeholder: true},
        tracks: {name: 'Tracks', text: 'Tracks', _id: 'tracks', placeholder: true},
        presentations: {name: 'Presentations', text: 'Presentations', _id: 'presentations', placeholder: true},
        polls: {name: 'Polls', text: 'Polls', _id: 'polls', placeholder: true},
        workshops: {name: 'Workshops', text: 'Workshops', _id: 'workshops', placeholder: true},
        assessments: {name: 'Assessments', text: 'Assessments', _id: 'assessments', placeholder: true},
        journeys: {name: 'Journeys', text: 'Journeys', _id: 'journeys', placeholder: true},
        scorm: {name: 'Scorm', text: 'Scorm', _id: 'scorm', placeholder: true},
        imported_content: {name: 'ImportedContent', text: 'Third-Party Content', _id: 'imported_content', placeholder: true},
        locations: {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true},
        departments: {name: 'Departments', text: 'Departments', _id: 'departments', placeholder: true},
        teams: {name: 'Teams', text: 'Teams', _id: 'teams', placeholder: true},
        org_levels: {name: 'OrgLevels', text: 'OrgLevels', _id: 'org_levels', placeholder: true},
        grades: {name: 'Grades', text: 'Grades', _id: 'grades', placeholder: true},
        categories: {name: 'Categories', text: 'Categories', _id: 'categories', placeholder: true},
        groups: {name: 'Groups', text: 'Groups', _id: 'groups', placeholder: true}
      };

      function setTracks(list, items, addedItems) {
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (!item || !item.name || !item._id) {
            continue;
          }
          // Learn Global Instructional Tracks
          if (item._id === '5671e6f377c9615f392c7650' || item._id === '56703b4cf372fe12008b009e') {
            continue;
          }
          // Prod Global Instructional Tracks
          if (item._id === '5653bc2d96c8dae34800011b' || item._id === '5696f5654ae9ed1000fdfc93') {
            continue;
          }
          if (!addedItems.tracks) {
            items.push(placeholders.tracks);
            addedItems.tracks = true;
          }
          items.push({
            name: item.name,
            text: item.name,
            _id: item._id,
            type: 'tracks'
          }); 
        }
      };

      function setPresentations(list, items, addedItems) {
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (!item || !item.title || !item._id) {
            continue;
          }
          if (!addedItems.presentations) {
            items.push(placeholders.presentations);
            addedItems.presentations = true;
          }
          items.push({
            name: item.title,
            text: item.title,
            _id: item._id,
            type: 'presentations'
          }); 
        }
      };

      function setWorkshops(list, items, addedItems) {
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (!item || !item.title || !item._id) {
            continue;
          }
          if (!addedItems.workshops) {
            items.push(placeholders.workshops);
            addedItems.workshops = true;
          }
          items.push({
            name: item.title,
            text: item.title,
            _id: item._id,
            type: 'workshops'
          }); 
        }
      };

      function setAssessments(list, items, addedItems) {
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (!item || !item.title || !item._id) {
            continue;
          }
          if (!addedItems.assessments) {
            items.push(placeholders.assessments);
            addedItems.assessments = true;
          }
          items.push({
            name: item.title,
            text: item.title,
            _id: item._id,
            type: 'assessments'
          }); 
        }
      };
      
      function setScorm(list, items, addedItems) {
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (!item || !item.title || !item._id) {
            continue;
          }
          if (!addedItems.scorm) {
            items.push(placeholders.scorm);
            addedItems.scorm = true;
          }
          items.push({
            name: item.title,
            text: item.title,
            _id: item._id,
            type: 'scorm'
          }); 
        }
      };
      
      function setImportedContent(list, items, addedItems) {
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (!item || !item.title || !item._id) {
            continue;
          }
          if (!addedItems.imported_content) {
            items.push(placeholders.imported_content);
            addedItems.imported_content = true;
          }
          items.push({
            name: item.title,
            text: item.title,
            _id: item._id,
            type: 'imported_content'
          }); 
        }
      };

      function setContent(list, items, addedItems) {
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          var type = item.type + 's'
          if (!item || !item.title || !item._id) {
            continue;
          }
          if (!addedItems[type]) {
            items.push(placeholders[type]);
            addedItems[type] = true;
          }

          items.push({
            name: item.title,
            text: item.title,
            _id: item._id,
            type: type
          }); 
        }
      };

      function setJourneys(list, items, addedItems) {
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          var type = item.type + 's'
          if (!item || !item.title || !item._id) {
            continue;
          }
          if (!addedItems[type]) {
            items.push(placeholders[type]);
            addedItems[type] = true;
          }

          items.push({
            name: item.title,
            text: item.title,
            _id: item._id,
            type: type
          }); 
        }
      };

      self.getOptions = function(input) {
        var deferred = $q.defer();
        input = input ? input.toLowerCase() : '';
        input = input.replace('[','\\[').replace(']','\\]').replace('*','\\*').replace('+','\\+').replace('(','\\(').replace(')','\\)').replace('>','\\>').replace('<','\\<');

        var addedItems = {
          articles: false,
          files: false,
          videos: false,
          tracks: false,
          presentations: false,
          polls: false,
          workshops: false,
          assessments: false,
          journeys: false,
          locations: false,
          departments: false,
          teams: false,
          org_levels: false,
          grades: false,
          categories: false,
          groups: false
        };

        var query = {
          subresource: '',
          page: 1,
          per_page: 6,
          '$or': '10,title,$regex,2,' + input + ',i,name,$regex,2,' + input + ',i'
        };
        if ($scope.pendingContent === 'yes') {
          query.approval_required = true;
        }

        if ($scope.myContentOnly === 'yes' && !Authorization.isCollaborator()) {
          // Collaborator restriction is handled in api
          query.user = Application.access.user._id;
        }

        if ($scope.for === 'archived') {
          delete query.subresource;
          query.archived = true;
        }

        self.searchContent(query)
        .then(function(results) {
          var items = [];

          var setOptions = {
            article: setContent,
            file: setContent,
            video: setContent,
            track: setTracks,
            presentation: setPresentations,
            workshop: setWorkshops,
            assessment: setAssessments,
            scorm: setScorm,
            imported_content: setImportedContent,
            journey: setJourneys,
          };

          var contentBlock = {
            article: [],
            file: [],
            video: [],
            track: [],
            presentation: [],
            workshop: [],
            assessment: [],
            scorm: [],
            imported_content: [],
            journey: []                
          };

          results.data.forEach(function (item) {
            if (!item.type || !contentBlock[item.type]) {
              if (item.type === 'multi_session_workshop') {
                contentBlock['workshop'].push(item);
              }
              return;
            }

            contentBlock[item.type].push(item);
          });

          for (var key in contentBlock) {
            if (!contentBlock[key] || !contentBlock[key].length) {
              continue;
            }

            setOptions[key](contentBlock[key], items, addedItems);
          }


          if (!$scope.forAssignments) {

            // Add locations to options
            for (var loc in self.locations) {
              if (new RegExp(input).test(self.locations[loc].name.toLowerCase()) && !self.queryIds[self.locations[loc]._id]) {
                if (!addedItems.locations) {
                  items.push(placeholders.locations);
                  addedItems.locations = true;
                }
                items.push({
                  name: self.locations[loc].name,
                  text: self.locations[loc].legacyName,
                  _id: self.locations[loc]._id,
                  type: 'location'
                });
              }
            }
            for (var dep in self.departments) {
              if (new RegExp(input).test(self.departments[dep].name.toLowerCase()) && !self.queryIds[self.departments[dep]._id]) {
                if (!addedItems.departments) {
                  items.push(placeholders.departments);
                  addedItems.departments = true;
                }
                items.push({
                  name: self.departments[dep].name,
                  text: self.departments[dep].legacyName,
                  _id: self.departments[dep]._id,
                  type: 'department'
                });
              }
            }
            for (var team in self.teams) {
              if (new RegExp(input).test(self.teams[team].name.toLowerCase()) && !self.queryIds[self.teams[team]._id]) {
                if (!addedItems.teams) {
                  items.push(placeholders.teams);
                  addedItems.teams = true;
                }
                items.push({
                  name: self.teams[team].name,
                  text: self.teams[team].legacyName,
                  _id: self.teams[team]._id,
                  type: 'team'
                });
              }
            }
            for (var org_level in self.org_levels) {
              if (new RegExp(input).test(self.org_levels[org_level].name.toLowerCase()) && !self.queryIds[self.org_levels[org_level]._id]) {
                if (!addedItems.org_levels) {
                  items.push(placeholders.org_levels);
                  addedItems.org_levels = true;
                }
                items.push({
                  name: self.org_levels[org_level].name,
                  text: self.org_levels[org_level].legacyName,
                  _id: self.org_levels[org_level]._id,
                  type: 'org_level'
                });
              }
            }
            for (var grade in self.grades) {
              if (new RegExp(input).test(self.grades[grade].name.toLowerCase()) && !self.queryIds[self.grades[grade]._id]) {
                if (!addedItems.grades) {
                  items.push(placeholders.grades);
                  addedItems.grades = true;
                }
                items.push({
                  name: self.grades[grade].name,
                  text: self.grades[grade].legacyName,
                  _id: self.grades[grade]._id,
                  type: 'grade'
                });
              }
            }
            for (var cat in self.categories) {
              if ($scope.for === 'poll-result') {
                break;
              }
              if (new RegExp(input).test(self.categories[cat].name.toLowerCase()) && !self.queryIds[self.categories[cat]._id]) {
                if (!addedItems.categories) {
                  items.push(placeholders.categories);
                  addedItems.categories = true;
                }
                items.push({
                  name: self.categories[cat].name,
                  text: self.categories[cat].legacyName,
                  _id: self.categories[cat]._id,
                  type: 'category'
                });
              }
            }

            for (const group in self.groups) {
              if (new RegExp(input).test(self.groups[group].name.toLowerCase()) && !self.queryIds[self.groups[group]._id]) {
                if (!addedItems.groups) {
                  items.push(placeholders.groups);
                  addedItems.groups = true;
                }
                items.push({
                  name: self.groups[group].name,
                  text: self.groups[group].name,
                  _id: self.groups[group]._id,
                  type: 'group'
                });
              }
            }
          }

          deferred.resolve(items);
        });

        return deferred.promise;
      };

      self.initialize = async function() {
        if ($scope.contentOnly) {
          return
        }
        const data = await Categories.find({
          fields: ['_id', 'name', 'localized_names', 'category', 'location', 'department', 'team', 'org_level', 'grade', 'company', 'level', 'group', 'parent', 'children'].join(','),
          $or: '10,location,true,department,true,team,true,org_level,true,grade,true',
          sort: 'name,1'
        }).$promise;

        const groupData = await Groups.find({
          fields: ['_id', 'name'].join(','),
          sort: 'name,1'
        }).$promise;

        groupData.forEach(group => group.group = true);
        data.push(...groupData);

        self.sortCategories(data);
        if ($scope.categoryDirectory) {
          $scope.categoryDirectory.locations = self.locations;
          $scope.categoryDirectory.departments = self.departments;
          $scope.categoryDirectory.teams = self.teams;
          $scope.categoryDirectory.org_levels = self.org_levels;
          $scope.categoryDirectory.grades = self.grades;
          $scope.categoryDirectory.groups = self.groups;
        }
      };

      self.initialize();

      $scope.$watch('clear', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.removeTags();
          $scope.clear = false;
        }
      });

      var initialWatch = $scope.$watch('initialValues', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        newVal.forEach(function (value) {
          if (!value.name) {
            throw Error('Initial values must have name specified');
          }
          self.outsideAdd(value);
        });
        initialWatch();
      });
    }],
    controllerAs: 'search'
  };
}]);